import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { matchPath } from "react-router";
import queryString from "query-string";

import SVG from "../../../components/SVG";
import { Container, Col, Row, Button } from "../../../components/simple";
import VariablesBuilder from "./VariablesBuilder";
import LocationBuilder from "./LocationBuilder";
import AudienceDescription from "./AudienceDescription";
import PrecisionSlider from "./PrecisionSlider";
import ModalMap from "../../../components/complex/AudinceMap/ModalMap";
import { ModalAudienceForm } from "../../../components/forms/CreateAudienceDescription";
import { ModalSelectClientBeforePush } from "../../../components/forms/ModalSelectClientBeforePush";
import PushModal from "../PushModal";
import LimitWarning from "../PushModal/LimitWarning";
import Modal from "../../../components/simple/Modal";

import * as routes from "../../../router/routes";
import Api from "../../../api";
import {
  clearDescription,
  clearStats,
  clearTags,
  audienceSubcategoriesClear,
  audienceVariablesClear
} from "../../../store/entities/audience/audience.actions";

import "../../../styles/pages/audiencesCreate.scss";
import styles from "./create-without-template.module.scss";
import "./create-without-template.scss";

class AudienceCreateWithoutTemplate extends Component {
  constructor(props) {
    super(props);
    const {
      location: { state }
    } = props;

    this.state = {
      selectedVariables: [],
      selectedRegions: [],
      isBuilderLocationOpen: false,
      ...state,
      country: state?.country || state?.audience?.country.name,
      isBuilderOpen: false,
      isHelpPopper: false,
      isMapOpen: false,
      threshold:
        typeof state?.audience?.threshold === "number"
          ? state?.audience?.threshold
          : 70,
      isCategoriesLoading: false,
      isShowPushModal: false,
      isLimitWarningModalOpen: false,
      adformToken: "",
      snapchatToken: "",
      isDescriptionModalOpen: false,
      isSelectClientModalOpen: false,
      isAudienceUpdated: false,
      selectedClient: null,
      precisionLoader: false
    };
    this.handleVariablesSubmit = this.handleVariablesSubmit.bind(this);
    this.handleRegionsSubmit = this.handleRegionsSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleMapModal = this.handleMapModal.bind(this);
    this.handleHelpPopper = this.handleHelpPopper.bind(this);
    this.handleDescriptionModal = this.handleDescriptionModal.bind(this);
    this.handleDescriptionChange = this.handleDescriptionChange.bind(this);
  }

  async componentDidMount() {
    const {
      location,
      clearPersonaDescription,
      clearCalculatedAudience,
      clearTagCloud,
      clearSubcategories,
      clearVariables,
      companyPlan,
      clients
    } = this.props;

    const params = queryString.parse(location.search);

    if (params.adformToken) {
      this.setState({
        isShowPushModal: true,
        selectedClient: this.props.location.state.clientId,
        adformToken: params.adformToken
      });
    }

    if (params.snapchatToken) {
      this.setState({
        isShowPushModal: true,
        selectedClient: this.props.location.state.clientId,
        snapchatToken: params.snapchatToken
      });
    }

    const matched = matchPath(location.pathname, {
      path: routes.audiencesCreateWithoutTemplate(routes.slugId),
      exact: true,
      strict: false
    });

    clearPersonaDescription();
    clearCalculatedAudience();
    clearTagCloud();
    clearSubcategories();
    clearVariables();

    document.title = "Audience Builder | Global Data Resources";

    try {
      if (!Object.keys(clients).length) {
        await Api.client.get();
      }

      if (!Object.keys(companyPlan).length) {
        await Api.subscription.get();
      }

      if (location?.state?.from !== "createFromTemplate") {
        await this.getAllStats(matched.params.id, true);
      }

      if (this.state.country?.length) {
        const { audience, threshold } = this.state;
        if (this.state.selectedVariables?.length > 0) {
          Api.audience.map({
            data: { audienceId: audience.id, threshold }
          });
        }

        await this.getData();
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    const matched = matchPath(this.props.location.pathname, {
      path: routes.audiencesCreateWithoutTemplate(routes.slugId),
      exact: true,
      strict: false
    });

    if (
      this.state.isAudienceUpdated !== prevState.isAudienceUpdated &&
      this.state.isAudienceUpdated === true
    ) {
      this.showModal();

      this.getAllStats(matched.params.id, true).then(() => {
        this.setState({ isAudienceUpdated: false });
      });
    }

    if (
      Object.keys(this.props.stats).length &&
      prevProps.stats !== this.props.stats
    ) {
      this.setResponseStatsData();
    }

    if (prevState.country !== this.state.country) {
      await this.getData();
    }
  }

  showModal = () => {
    if (!this.props.companyPlan.limitedFunctionality)
      this.setState({ isShowPushModal: true });
    else if (this.props.companyPlan.limitedFunctionality)
      this.setState({
        isLimitWarningModalOpen: true
      });
  };

  setResponseStatsData = () => {
    const { threshold, country, audienceVariables } = this.props.stats;
    this.setState({
      audience: this.props.stats,
      threshold,
      country: country.name,
      selectedVariables: audienceVariables
    });
  };

  getData = async () => {
    const { country } = this.state;
    const { clearSubcategories, clearVariables } = this.props;
    this.setState({ isCategoriesLoading: true });
    this.getAllRegions();

    await Api.audience.countries({
      params: {
        has_data: true
      }
    });

    await Api.audience.categories({
      params: { country__name: country }
    });

    clearSubcategories();
    clearVariables();
    if (this.props.categories.length) {
      const getSubcategories = Api.audience.subcategories({
        params: { category__country__name: country }
      });
      const getVariables = Api.audience.variables({
        params: { country__name: country }
      });
      // const getSubcategories = this.props.categories.map(category => {
      //   return Api.audience.subcategories({
      //     params: { category_id: category.id }
      //   });
      // });
      // await Promise.all(getSubcategories);
      // const getVariables = this.props.subcategories.map(subcategory => {
      //   return Api.audience.variables({
      //     params: { sub_category_id: subcategory.id }
      //   });
      // });

      // await Promise.all(getVariables);
      await Promise.all([getSubcategories, getVariables]);
    }

    this.setState({ isCategoriesLoading: false });
  };

  getAllStats = async (audienceId, isInitialRequest = false) => {
    const { threshold } = this.state;

    if (
      isInitialRequest &&
      this.props.location?.state?.from !== "createFromTemplate"
    ) {
      const response = await Api.audience.getSingleAudience({ id: audienceId });
      this.setState({
        audience: response,
        threshold: response.threshold,
        selectedVariables: response.audienceVariables
      });
    } else {
      // await Api.audience.stats({
      //   data: { audienceId, threshold, type: "audience" }
      // });
    }

    if (this.state.selectedVariables?.length > 0) {
      await Api.audience.tags({
        data: { audienceId, threshold }
      });
      await Api.audience.personaDescription({
        data: { audienceId, threshold }
      });
    }
  };

  onSelectClient = async data => {
    const { id, name, clientsId } = data;

    const response = await Api.audience.edit({
      id,
      data: {
        name,
        client: clientsId
      }
    });

    if (response.id)
      this.setState({ isAudienceUpdated: true, selectedClient: clientsId });

    this.handleSelectClientModal(false);
  };

  handleSelectClientModal = isSelectClientModalOpen => {
    return this.setState({ isSelectClientModalOpen });
  };

  getAllRegions = async () => {
    const country = this.state?.audience?.country?.id;
    // eslint-disable-next-line
    const regions = this.state?.audience?.regions;
    this.setState({ selectedRegions: regions });
    await Api.audience.regions({
      data: { country }
    });
  };

  async handleVariablesSubmit(selectedVariables) {
    this.setState({ selectedVariables });
    const { audience } = this.state;
    const {
      history,
      clearPersonaDescription,
      clearCalculatedAudience,
      clearTagCloud
    } = this.props;

    clearPersonaDescription();
    clearCalculatedAudience();
    clearTagCloud();
    // eslint-disable-next-line
    const { regions, newAudience } = audience;
    this.setState({ precisionLoader: true });
    const response = await Api.audience.edit({
      id: audience.id,
      data: {
        ...newAudience,
        audienceType: "Custom",
        country: audience.country.name,
        variables: selectedVariables.map(group =>
          group.map(variable => variable.id)
        ),
        client: audience.client ? audience.client.id : null
      }
    });
    const { threshold, country, audienceVariables } = response;
    this.setState({
      audience: response,
      threshold,
      country: country?.name,
      selectedVariables: audienceVariables
    });
    this.setState({ precisionLoader: false });
    await this.getAllStats(audience.id);
    await Api.audience.map({
      data: { audienceId: audience?.id, threshold }
    });

    history.push(routes.audiencesCreateWithoutTemplate(audience.id), {
      selectedVariables,
      country: audience.country.name
      // audience,
    });
  }

  async handleRegionsSubmit(selectedRegions) {
    const { audience } = this.state;
    this.setState({ precisionLoader: true });
    const res = selectedRegions.map(item => {
      return item.id;
    });
    const response = await Api.audience.edit({
      id: audience.id,
      data: {
        regions: res
      }
    });
    const { threshold, country, audienceVariables, regions } = response;
    this.setState({
      audience: response,
      threshold,
      country: country.name,
      selectedVariables: audienceVariables,
      selectedRegions: regions
    });
    this.setState({ precisionLoader: false });

    await this.getAllStats(audience.id);
    await Api.audience.map({
      data: { audienceId: audience?.id, threshold }
    });
  }

  async handleMapModal() {
    // const {
    //   audience: { id },
    //   threshold
    // } = this.state;

    // await Api.audience.map({
    //   data: { audienceId: id, threshold }
    // });
    this.setState({ isMapOpen: true });
  }

  handleHelpPopper() {
    return this.setState(({ isHelpPopper }) => ({
      isHelpPopper: !isHelpPopper
    }));
  }

  async handleChange() {
    const { audience } = this.state;
    const { threshold, selectedVariables } = this.state;
    if (selectedVariables && selectedVariables.length) {
      Api.audience.stats({
        data: { audienceId: audience?.id, threshold, type: "audience" }
      });
      Api.audience.map({
        data: { audienceId: audience?.id, threshold }
      });
    }
  }

  async handleDescriptionChange(data) {
    const { isDescriptionModalOpen } = this.state;
    const { regions, ...rest } = data;

    if (rest.id) {
      await Api.audience.edit({
        id: rest.id,
        data: {
          ...rest,
          variables: rest.audienceVariables.map(group =>
            group.map(variable => variable.id)
          ),
          client: rest.clientsId ? rest.clientsId : null
        }
      });
      this.handleDescriptionModal(!isDescriptionModalOpen);
      await this.getAllStats(data.id);
    }
  }

  handleDescriptionModal(isDescriptionModalOpen) {
    return this.setState({ isDescriptionModalOpen });
  }

  render() {
    const {
      audience = {},
      selectedVariables = [],
      selectedRegions = [],
      isBuilderOpen,
      isBuilderLocationOpen,
      isMapOpen,
      threshold,
      isCategoriesLoading,
      isShowPushModal,
      isLimitWarningModalOpen,
      adformToken,
      snapchatToken,
      isDescriptionModalOpen,
      selectedClient,
      precisionLoader
    } = this.state;

    const {
      user,
      clients,
      tags,
      mapData,
      personaDescription,
      isLoading,
      isLoadingPersonaDescription,
      isLoadingTags,
      isLoadingStats,
      regionsList
    } = this.props;
    // const data = audience && Object.keys(audience).length ? audience : stats;
    // const data = stats;
    const data = audience;
    const flatSelectedVariables = selectedVariables.flat();
    const hasInactiveVariables =
      flatSelectedVariables.findIndex(variable => !variable.active) > -1;
    return (
      <Container id="audiences-create" fluid>
        <Row className={styles["audiences-wrapper"]}>
          <Col md={6} className={styles["audiences-container"]}>
            <Row className="audiences-dashboard">
              <h2 className={`${styles.header}`}>{data?.name}</h2>
            </Row>
            <Row>
              <div
                className={`w-100 d-flex justify-content-between ${styles["heading-container"]}`}
              >
                <div className={styles["sub-header"]}>
                  <span>Selected variables</span>
                </div>
                <Button
                  className="btn-transparent"
                  onClick={() =>
                    this.setState({ isBuilderOpen: !isBuilderOpen })
                  }
                >
                  <span className={styles["btn-underline"]}>
                    <SVG.Edit
                      width={14}
                      height={14}
                      className={styles["edit-icon"]}
                    />
                    Edit list
                  </span>
                </Button>
              </div>
            </Row>
            <Row>
              <VariablesBuilder
                toggle={() => this.setState({ isBuilderOpen: !isBuilderOpen })}
                isOpen={isBuilderOpen}
                selectedVariables={selectedVariables}
                onSelect={this.handleVariablesSubmit}
                isCategoriesLoading={isCategoriesLoading}
              />
            </Row>
            {audience?.country?.hasRegions ? (
              <>
                <Row>
                  <div
                    className={`w-100 d-flex justify-content-between ${styles["heading-container"]}`}
                  >
                    <div className={styles["sub-header"]}>
                      <span>Selected Location</span>
                    </div>
                    <Button
                      className="btn-transparent"
                      onClick={() =>
                        this.setState({
                          isBuilderLocationOpen: !isBuilderLocationOpen
                        })
                      }
                    >
                      <span className={styles["btn-underline"]}>
                        <SVG.Edit
                          width={14}
                          height={14}
                          className={styles["edit-icon"]}
                        />
                        Edit list
                      </span>
                    </Button>
                  </div>
                </Row>
                <Row>
                  <LocationBuilder
                    toggle={() =>
                      this.setState({
                        isBuilderLocationOpen: !isBuilderLocationOpen
                      })
                    }
                    isOpen={isBuilderLocationOpen}
                    regionsList={regionsList}
                    selectedRegions={selectedRegions}
                    country={audience.country}
                    onSelect={this.handleRegionsSubmit}
                    // isLoading={isLoading || isCategoriesLoading}
                  />
                </Row>
              </>
            ) : null}

            <Row style={{ marginTop: 61, marginBottom: 50 }}>
              <PrecisionSlider
                value={threshold}
                reach={data?.reachLl}
                population={data?.populationLl}
                precision={data?.precisionLl}
                qualityIndicator={data?.qualityIndicator}
                onAfterChange={this.handleChange}
                onChange={newTreshold => {
                  this.setState({ threshold: newTreshold });
                }}
                disabled={
                  (selectedVariables && !selectedVariables.length) ||
                  hasInactiveVariables
                }
                isLoading={isLoadingPersonaDescription || isLoading}
                isLoadingStats={isLoadingStats || precisionLoader || isLoading}
              />
            </Row>
            <Row className={styles.buttons}>
              <div className="d-flex flex-row mt-4">
                <Button
                  onClick={() => {
                    this.handleSelectClientModal(true);
                  }}
                  className={`button ${styles["button-activate"]}`}
                  disabled={
                    isLoading ||
                    (selectedVariables && !selectedVariables.length) ||
                    hasInactiveVariables
                  }
                >
                  Activate
                </Button>
                <Button
                  onClick={() => {
                    this.setState(
                      this.handleDescriptionModal(!isDescriptionModalOpen)
                    );
                  }}
                  className={`${styles["button-save"]}`}
                  disabled={isLoading}
                >
                  SAVE
                </Button>
              </div>
              <div></div>
            </Row>
          </Col>
          <Col md={6} className={styles["audience-description"]}>
            <AudienceDescription
              audience={audience}
              selectedVariables={selectedVariables}
              handleMapModal={this.handleMapModal}
              words={tags}
              personaDescription={personaDescription}
              nothingToShow={selectedVariables && !selectedVariables.length}
              isLoading={isLoadingPersonaDescription}
              isLoadingTags={isLoadingTags}
              isLoadingMapData={isLoading}
            />
          </Col>
        </Row>
        <ModalMap
          mapClassName="map-container"
          className="heatmap-modal"
          isOpen={isMapOpen}
          data={mapData.length ? mapData[0] : null}
          mapCenter={{
            lat: audience.country?.mapboxCenterLat,
            lng: audience.country?.mapboxCenterLon
          }}
          mapZoom={audience.country?.mapboxDefaultZoom}
          changeModalState={() => this.setState({ isMapOpen: !isMapOpen })}
        />
        <PushModal
          isOpen={isShowPushModal}
          onClose={() => {
            this.setState({ isShowPushModal: false });
          }}
          audience={data}
          adformToken={adformToken}
          snapchatToken={snapchatToken}
          user={user}
          clientId={selectedClient}
          currentSubscribtion={this.props.user.company.currentSubscribtion}
        />
        {isLimitWarningModalOpen && (
          <Modal
            isOpen={isLimitWarningModalOpen}
            handleClose={() =>
              this.setState({ isLimitWarningModalOpen: false })
            }
          >
            <LimitWarning
              onShow
              onPushAnyway={() => {
                this.setState({
                  isLimitWarningModalOpen: false,
                  isShowPushModal: true
                });
              }}
            />
          </Modal>
        )}
        <ModalAudienceForm
          data={data}
          type="audience_builder"
          clients={clients}
          isOpen={isDescriptionModalOpen}
          canChangeClient={user?.role === "admin" || user?.role === "gdr admin"}
          changeModalState={() =>
            this.handleDescriptionModal(!isDescriptionModalOpen)
          }
          handleSubmit={this.handleDescriptionChange}
        />
        <ModalSelectClientBeforePush
          modalTitle="Select your client"
          data={this.state.audience}
          type="audience"
          clients={clients}
          isOpen={this.state.isSelectClientModalOpen}
          changeModalState={() =>
            this.handleSelectClientModal(!this.state.isSelectClientModalOpen)
          }
          handleSubmit={this.onSelectClient}
        />
      </Container>
    );
  }
}

const mapStateToProps = ({ audiences, userProfile, clients }) => {
  return {
    user: userProfile.user,
    companyPlan: userProfile.companyPlan,
    audiences,
    clients: clients.data,
    categories: audiences.categories,
    subcategories: audiences.subcategories,
    regionsList: audiences.regionsList,
    tags: audiences.tags,
    stats: audiences.stats,
    mapData: audiences.map,
    personaDescription: audiences.description,
    isLoading: audiences.isLoading,
    isLoadingPersonaDescription: audiences.isLoadingPersonaDescription,
    isLoadingStats: audiences.isLoadingStats,
    isLoadingTags: audiences.isLoadingTags
  };
};

const mapDispatchToProps = dispatch => {
  return {
    clearSubcategories: () => dispatch(audienceSubcategoriesClear()),
    clearVariables: () => dispatch(audienceVariablesClear()),
    clearPersonaDescription: () => dispatch(clearDescription()),
    clearCalculatedAudience: () => dispatch(clearStats()),
    clearTagCloud: () => dispatch(clearTags())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AudienceCreateWithoutTemplate);

AudienceCreateWithoutTemplate.propTypes = {
  user: PropTypes.shape({
    role: PropTypes.string,
    company: PropTypes.shape({
      currentSubscribtion: PropTypes.string
    })
  }).isRequired,
  companyPlan: PropTypes.shape({
    limitedFunctionality: PropTypes.bool.isRequired
  }).isRequired,
  categories: PropTypes.arrayOf(PropTypes.shape({})),
  regionsList: PropTypes.arrayOf(PropTypes.shape({})),
  // subcategories: PropTypes.arrayOf(PropTypes.shape({})),
  tags: PropTypes.arrayOf(PropTypes.shape({})),
  personaDescription: PropTypes.arrayOf(PropTypes.shape({})),
  clients: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  mapData: PropTypes.arrayOf(PropTypes.object).isRequired,
  audiences: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  stats: PropTypes.shape({
    audienceVariables: PropTypes.arrayOf(
      PropTypes.arrayOf(PropTypes.shape({}))
    ),
    threshold: PropTypes.number,
    qualityIndicator: PropTypes.string,
    reachLl: PropTypes.number,
    populationLl: PropTypes.number,
    precisionLl: PropTypes.number,
    country: PropTypes.shape({
      name: PropTypes.string
    })
  }).isRequired,
  location: PropTypes.shape({
    search: PropTypes.string,
    pathname: PropTypes.string,
    state: PropTypes.shape({
      audience: PropTypes.shape({
        threshold: PropTypes.number,
        country: PropTypes.shape({
          name: PropTypes.string
        })
      }),
      country: PropTypes.string,
      tags: PropTypes.arrayOf(PropTypes.shape({})),
      personaDescription: PropTypes.arrayOf(PropTypes.shape({})),
      clientId: PropTypes.string,
      from: PropTypes.string
    })
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
    block: PropTypes.func
  }).isRequired,
  isLoading: PropTypes.bool.isRequired,
  isLoadingPersonaDescription: PropTypes.bool.isRequired,
  isLoadingTags: PropTypes.bool.isRequired,
  isLoadingStats: PropTypes.bool.isRequired,
  clearPersonaDescription: PropTypes.func.isRequired,
  clearCalculatedAudience: PropTypes.func.isRequired,
  clearSubcategories: PropTypes.func.isRequired,
  clearVariables: PropTypes.func.isRequired,
  clearTagCloud: PropTypes.func.isRequired
};

AudienceCreateWithoutTemplate.defaultProps = {
  categories: [],
  regionsList: [],
  // subcategories: [],
  personaDescription: [],
  tags: []
};
